function rehmanStartCountdown(duration) {
    var rehmanCountDownDate = localStorage.getItem("rehmanCountDownDate");

    if (!rehmanCountDownDate) {
        rehmanCountDownDate = new Date().getTime() + duration;
        localStorage.setItem("rehmanCountDownDate", rehmanCountDownDate);
    }

    var x = setInterval(function () {
        var now = new Date().getTime();
        var rehmanDistance = rehmanCountDownDate - now;

        var rehmanHours = Math.floor((rehmanDistance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var rehmanMinutes = Math.floor((rehmanDistance % (1000 * 60 * 60)) / (1000 * 60));
        var rehmanSeconds = Math.floor((rehmanDistance % (1000 * 60)) / 1000);

        var element = document.getElementById("rehman-countdown");
        if (element) {
            element.innerHTML =
                rehmanHours + "h " +
                rehmanMinutes + "m " +
                rehmanSeconds + "s";
        }

        if (rehmanDistance < 0) {
            clearInterval(x);
            localStorage.removeItem("rehmanCountDownDate");
            rehmanStartCountdown(duration);
        }
    }, 1000);
}

document.addEventListener("DOMContentLoaded", function () {
    rehmanStartCountdown(7980000);
});
